import ResetPasswordLink from "./ResetPasswordLink";

export default ResetPasswordLink;